import { atom } from 'jotai';

export const regulatoryGuidelineBlockModalOpenAtom = atom(false);
